'use client';

import { ReactNode } from 'react';

import { DisplayHeading } from '@/components/editorial/display-heading';

interface PageHeadingProps {
  children: ReactNode;
}

export const PageHeading = ({ children }: PageHeadingProps) => {
  return (
    <DisplayHeading as="h1" size="lg" animate className="mb-8">
      {children}
    </DisplayHeading>
  );
};
